export default "__VITE_ASSET__C53IM9e4__"